import type { IEventClusterRequestParams } from '@/pages/intelligence/services/eventCluster';
import type { IOpinionChartEventData } from '../types';

const eventClusterCache = new Map<string, IOpinionChartEventData>();

export function buildEventClusterCacheKey(
  params: Pick<
    IEventClusterRequestParams,
    'game_ids' | 'start_date' | 'end_date'
  > & { date_type?: string },
): string {
  const gameIds = [...(params.game_ids || [])].sort().join(',');
  return `${gameIds}::${params.start_date}::${params.end_date}::${params.date_type || ''}`;
}

export function getCachedEventClusterData(
  cacheKey?: string,
): IOpinionChartEventData | null {
  if (!cacheKey) {
    return null;
  }

  return eventClusterCache.get(cacheKey) || null;
}

export function setCachedEventClusterData(
  cacheKey: string,
  eventData: IOpinionChartEventData,
): void {
  eventClusterCache.set(cacheKey, eventData);
}
